// extracted by mini-css-extract-plugin
export default {"Event":"Event_Event__eghQY"};